import {to_isAddressable} from "@Common/logic/template-options/template-options-is-addressable";

import {cleanItem, itemEditor, ui} from "../expo-types/expo-types";

import {AddressListsLogic} from "./address-lists-logic";

export const addressListsModules = ({entityId, item, templateOptions}) => [

    {
        name: "addressLists1",
        load: ({}, next) => AddressListsLogic({entityId, item, next}),
        expo: [cleanItem],
    },

    {
        name: "addressLists2",
        load: ({method, addressLists1, enableAddressableShippingLogic2}, next) => (
            (
                method === "mailing" ||
                (
                    (method === "shipping" || method === "pickup") &&
                    to_isAddressable(templateOptions) &&
                    enableAddressableShippingLogic2?.state.value
                )
            ) ? (
                addressLists1.next({next})
            ) : (
                next(null)
            )
        ),
        requires: ["method", "addressLists1"],
        requiresOptional: ["enableAddressableShippingLogic2"],
    },
    {
        name: "mailingListIds",
        load: ({addressLists2}, next) => next(addressLists2?.mailingListIds),
        requires: ["addressLists2"],
    },

    {
        name: "addressLists3",
        load: ({totalQuantity, addressLists2, paperPrice}, next) => (
            !addressLists2 ? (
                next(null)
            ) : addressLists2.next({
                totalQuantity,
                paperPrice,
                next,
            })
        ),
        requires: ["totalQuantity", "addressLists2", "paperPrice"],
        expo: [itemEditor, ui("addressLists")],
    },

];